import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {UserPromotion} from 'src/app/domain/model/user/user-promotion.model';

export interface UserPromotionState {
  promotions: UserPromotion[] | null;
}

const emptyState = () => ({
  promotions: null,
});

@Injectable({
  providedIn: 'root',
})
export default class UserPromotionStore extends ComponentStore<UserPromotionState> {
  public readonly promotions$ = this.select(state => state.promotions);

  constructor() {
    super(emptyState());
  }

  saveAll(promotions: UserPromotion[]): void {
    this.patchState(() => ({
      promotions
    }));
  }

  syncAll(): UserPromotion[] | null {
    return this.get().promotions;
  }

  reset(): void {
    this.patchState(() => ({
      ...emptyState()
    }));
  }
}
